import { Outlet } from 'react-router';

import { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

import { FixtureTabLayout } from '#src/layouts/FixtureLayout/FixtureTabLayout/index.tsx';

const FootballFixtureLayout = () => {
  const { currentUser } = useCurrentUserContext();
  const {
    flags: { enableNavToggleProSet = false },
  } = useFeatureFlags();

  if (enableNavToggleProSet || !currentUser?.anyUserSportProfile?.proUnlocked) {
    return (
      <>
        <Outlet />
      </>
    );
  }
  return (
    <FixtureTabLayout
      so5FixtureSlug="ongoing"
      eventType={So5FixtureEvent.CLASSIC}
    >
      <Outlet />
    </FixtureTabLayout>
  );
};
export default FootballFixtureLayout;
